import type { TOC } from '@ember/component/template-only';

import styles from './modal-filter-bar.module.css';

interface GeneralModalFilterBarSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const GeneralModalFilterBar = <template>
  <div class={{styles.container}} data-test-id="modal-filter-bar" ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<GeneralModalFilterBarSignature>;

export default GeneralModalFilterBar;
